var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:" z-10  absolute top-1/3  p-4 bg-purple dark:bg-purple rounded-full shadow-xl cursor-pointer",class:[_vm.direction === 'right' ? 'arrow-right -right-5' : 'arrow-left -left-5']})])}
var staticRenderFns = []

export { render, staticRenderFns }